import  styled from "@emotion/styled";

export const Button = styled.p`
    font-size: 1.5rem;
    font-weight: bold;
    padding: 0.5rem 0.5rem;
    border-radius: 7px;
    &:hover{
        cursor: pointer;
    }
    @media only screen and (max-width: 600px){
        text-align: center;
        background-color: black;
        color: white;
        border-radius: 0px;
        &:hover{
            background-color: grey;
        }
    }
`;

export const Field = styled.div`
    display: block;
    /* border: 1px solid red; */
    /* width: 600px; */
    padding: 1rem;

    label, p{
        color: white;
        margin-bottom: 5px;
        /* text-decoration: underline; */
        font-weight: bold;
        font-size: 1.5rem;
    }
    input[type = number], [type = text]{
        border-radius: 6px;
        color: #1d2129;
        padding: 0.5rem 0;
        width: 23vw;
        /* width: 50%; */
        /* width: 480px; */
        /* width: */
        border: 3px solid #DDDFE2;
        margin-left: 5px;
    }
    textarea{
        width: 40vw;
        height: 4vw;
    }
    @media only screen and (max-width: 720px){
        label{
            display: block;
        }
        input[type = text], [type = number]{
            width: 62vw;
        }
        textarea{
            width: 70vw;
            height: 30vw;
        }
    }
    @media only screen and  (min-width: 992px){
        input[type = text]{
            width: 29vw;
        }
    }
    @media only screen and  (min-width: 1600px){
        input[type = text]{
            width: 23vw;
        }
    }
    
    select, input[type = file]{
        font-size: 1.2rem;
        padding: 0.2rem;
        border-radius: 6px;
        /* background-color: black; */
    }
`;

export const Fieldset = styled.fieldset`
        /* margin: 2rem 0; */
        border: 5px solid #e1e1e1;
        border-radius: 6px;
        font-size: 2rem;
        padding: 2rem;
        @media only screen and (max-width: 720px){
            padding: 0.2rem;
        }
`;

export const Legend = styled.legend`
    color: white;
    font-weight: bold;
    font-size: 1.5rem;

`;